import { render, staticRenderFns } from "./CaseTypesGrid.vue?vue&type=template&id=220ec98a&"
import script from "./CaseTypesGrid.vue?vue&type=script&lang=js&"
export * from "./CaseTypesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports